// Dependencias
import Phaser from 'phaser';
import axiosInstance from '../../../../services/AxiosInstance';
import { startDeferring, stopDeferring } from '../../../../utils/saldoControl';

// Funciones JuegoRuleta
import { creacionElementosPrincipal } from './creacionElementos/creacionElementosPrincipal';
import { creacionParametrosPrincipal } from './creacionParametros/creacionParametrosPrincipal';
import { obtenerCoordenadasPorPosicion } from './funciones/obtenerCoordenadasPorPosicion';

class JuegoRuleta extends Phaser.Scene {
  /*/=======================================================================================\*\
  ||                               //? Constructor                                           ||
  \*\=======================================================================================/*/

  constructor() {
    super({ key: 'JuegoRuleta' });
  }

  /*/=======================================================================================\*\
  ||                               InicioPrecarga                                            ||
  \*\=======================================================================================/*/

  preload() {}

  /*/=======================================================================================\*\
  ||                               InicioCreate                                              ||
  \*\=======================================================================================/*/

  create() {
    creacionElementosPrincipal(this);
    creacionParametrosPrincipal(this);
    this.mostrarApuestaTotal();
    this.mostrarPremioTotal();

    this.events.once('shutdown', () => {
      clearTimeout(this._timeoutPremio);
    });
    this.events.once('destroy', () => {
      clearTimeout(this._timeoutPremio);
    });
  }

  /*/=======================================================================================\*\
  ||                               FUNCIONES                                                 ||
  \*\=======================================================================================/*/

  // Muestra en el display de apuesta el valor total de la apuesta
  mostrarApuestaTotal() {
    const apuestaStr = this.apuestaTotal.toString();

    let xPosition = 974;
    const yPosition = 470;

    this.limpiarApuestaTotal();

    for (let i = apuestaStr.length - 1; i >= 0; i--) {
      const digito = apuestaStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      this.imagenesNumerosApuesta.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Limpia el display de apuesta
  limpiarApuestaTotal() {
    this.imagenesNumerosApuesta.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesNumerosApuesta = [];
  }

  // Muestra en el display de premio el valor total del premio
  mostrarPremioTotal() {
    const premioStr = this.premioTotal.toString();

    let xPosition = 760;
    const yPosition = 66;

    this.limpiarPremioTotal();

    for (let i = premioStr.length - 1; i >= 0; i--) {
      const digito = premioStr[i];

      const imagenDigito = this.add.image(
        xPosition,
        yPosition,
        `numeroDisplay${digito}`
      );
      this.imagenesNumerosPremio.push(imagenDigito);
      xPosition -= 16;
    }
  }

  // Actualiza el premio total mostrando los números intermedio en el display
  actualizarPremioTotal() {
    let xPosition = 760;
    const yPosition = 66;
    let acumGanancia = 0;
    const premioFinal = this.premioTotal;
    let aumentoIteracion = 5000;

    if (premioFinal >= 10000 && premioFinal < 100000) {
      aumentoIteracion = 500;
    } else if (premioFinal >= 100 && premioFinal < 100000) {
      aumentoIteracion = 50;
    } else if (premioFinal >= 10 && premioFinal < 100) {
      aumentoIteracion = 5;
    }

    const updateDisplay = () => {
      this.limpiarPremioTotal();

      // Convierte el valor actual a cadena
      const acumGananciaStr = acumGanancia.toString();

      // Reposiciona xPosition en cada iteración para cada número completo
      let currentXPosition = xPosition;

      for (let i = acumGananciaStr.length - 1; i >= 0; i--) {
        const digito = acumGananciaStr[i];
        const imagenDigito = this.add.image(
          currentXPosition,
          yPosition,
          `numeroDisplay${digito}`
        );
        this.imagenesNumerosPremio.push(imagenDigito);
        currentXPosition -= 16;
      }

      // Incrementa acumGanancia sin exceder premioFinal
      if (acumGanancia < premioFinal) {
        acumGanancia = Math.min(acumGanancia + aumentoIteracion, premioFinal); // Ajusta incremento sin superar premioFinal
        this._timeoutPremio = setTimeout(updateDisplay, 1); // Retraso de 1 ms entre cada incremento
      }
    };

    updateDisplay();
  }

  // Limpia el display de premio
  limpiarPremioTotal() {
    this.imagenesNumerosPremio.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesNumerosPremio = [];
  }

  // Muestra el display de apuesta con el valor en la alfombra
  mostrarApuestaAlfombra(posicion) {
    if (this.posicionesApuesta[posicion][1] > 0) {
      let coordenadas = obtenerCoordenadasPorPosicion(posicion);

      const apuestaStr = this.posicionesApuesta[posicion][1].toString();

      if (this.imagenDisplayAlfombra) {
        this.imagenDisplayAlfombra.destroy();
      }

      this.imagenDisplayAlfombra = this.add.image(
        coordenadas.x + 84,
        coordenadas.y,
        'displayMontoAlfombra'
      );
      this.imagenDisplayAlfombra.setDepth(200);

      for (let i = apuestaStr.length - 1; i >= 0; i--) {
        const digito = apuestaStr[i];

        const imagenDigito = this.add.image(
          coordenadas.x + 84 + 44,
          coordenadas.y,
          `numeroDisplay${digito}`
        );
        imagenDigito.setDepth(200);
        this.imagenesNumerosAlfombra.push(imagenDigito);
        coordenadas.x -= 16;
      }
    }
  }

  // Deja de mostrar el display de apuesta en la alfombra
  //noMostrarApuestaAlfombra(posicion) {
  noMostrarApuestaAlfombra() {
    //if (this.posicionesApuesta[posicion][1] > 0) {
    if (this.imagenDisplayAlfombra) {
      this.imagenDisplayAlfombra.destroy();
    }
    this.imagenesNumerosAlfombra.forEach((imagen) => {
      imagen.destroy();
    });
    this.imagenesNumerosAlfombra = [];
    //}
  }

  sumarApuestaAlfombra(posicion) {
    const saldoDisponible = this.game.saldoDisponible;
    const apuestaTotal = this.apuestaTotal;
    const valorFicha = this.fichaSeleccionadaValor;
    const apuestaPosicion = this.posicionesApuesta[posicion][1];

    if (
      apuestaTotal + valorFicha <= saldoDisponible &&
      apuestaPosicion + valorFicha <= 1000
    ) {
      this.posicionesApuesta[posicion][1] += valorFicha;
      this.posicionesApuesta[posicion][2].push(valorFicha);

      this.cargarFichasEnAlfombra();
      this.actualizarApuestaTotal(valorFicha);
      this.mostrarApuestaAlfombra(posicion);
    }
  }

  restarApuestaAlfombra(posicion) {
    if (this.posicionesApuesta[posicion][1] > 0) {
      const valorFicha = this.posicionesApuesta[posicion][2].pop();
      this.posicionesApuesta[posicion][1] += -valorFicha;

      this.actualizarApuestaTotal(-valorFicha);
      this.cargarFichasEnAlfombra();

      if (this.posicionesApuesta[posicion][1] > 0) {
        this.mostrarApuestaAlfombra(posicion);
      } else {
        if (this.imagenDisplayAlfombra) {
          this.imagenDisplayAlfombra.destroy();
        }
        if (this.imagenesNumerosAlfombra) {
          this.imagenesNumerosAlfombra.forEach((imagen) => {
            imagen.destroy();
          });
          this.imagenesNumerosAlfombra = [];
        }
      }
    }
  }

  borrarApuesta() {
    this.apuestaTotal = 0;
    this.mostrarApuestaTotal();

    for (
      let posicion = 0;
      posicion < this.posicionesApuesta.length;
      posicion++
    ) {
      this.posicionesApuesta[posicion][1] = 0;
      this.posicionesApuesta[posicion][2] = [];
      this.posicionesApuesta[posicion][5] = 0; // Resetear ganancia de la posición

      if (this.posicionesApuesta[posicion][3]) {
        this.posicionesApuesta[posicion][3].anims.stop();
        this.posicionesApuesta[posicion][3].removeFromDisplayList();
        this.posicionesApuesta[posicion][3].destroy();
        this.posicionesApuesta[posicion][3] = null;
      }
    }

    this.cargarFichasEnAlfombra();
    this.noMostrarApuestaAlfombra();
  }

  almacenarUltimaApuesta() {
    for (
      let posicion = 0;
      posicion < this.posicionesApuesta.length;
      posicion++
    ) {
      if (this.posicionesApuesta[posicion][1] > 0) {
        this.posicionesUltimaApuesta[posicion][1] =
          this.posicionesApuesta[posicion][1];

        // Limpiar array antes de copiar para evitar acumulación entre rondas
        this.posicionesUltimaApuesta[posicion][2] = [];
        for (
          let posArrMontos = 0;
          posArrMontos < this.posicionesApuesta[posicion][2].length;
          posArrMontos++
        ) {
          this.posicionesUltimaApuesta[posicion][2].push(
            this.posicionesApuesta[posicion][2][posArrMontos]
          );
        }
        // No compartir referencia del sprite, se recrea con cargarFichasEnAlfombra()
        this.posicionesUltimaApuesta[posicion][3] = null;
      } else {
        this.posicionesUltimaApuesta[posicion][1] = 0;
        this.posicionesUltimaApuesta[posicion][2] = [];
        this.posicionesUltimaApuesta[posicion][3] = null;
      }
      // Resetear ganancia de la última apuesta
      this.posicionesUltimaApuesta[posicion][5] = 0;
    }
  }

  repetirUltimaApuesta() {
    if (this.game.saldoDisponible >= this.game.valorUltimaApuesta) {
      // Primero borrar la apuesta actual para limpiar todo
      this.borrarApuesta();

      this.apuestaTotal = 0;
      for (
        let posicion = 0;
        posicion < this.posicionesApuesta.length;
        posicion++
      ) {
        if (this.posicionesUltimaApuesta[posicion][1] > 0) {
          this.apuestaTotal += this.posicionesUltimaApuesta[posicion][1];

          this.posicionesApuesta[posicion][1] =
            this.posicionesUltimaApuesta[posicion][1];

          // Copiar array de montos (sin acumular)
          this.posicionesApuesta[posicion][2] = [
            ...this.posicionesUltimaApuesta[posicion][2],
          ];
        }
        // Ganancia siempre en 0 al repetir
        this.posicionesApuesta[posicion][5] = 0;
      }

      this.mostrarApuestaTotal();
      this.cargarFichasEnAlfombra();
    }
  }

  moverNumeros(numeroGanador, color) {
    this.bolillaFondo.setVisible(false);
    this.bolillaValor.setVisible(false);
    this.numerosMovimiento.setVisible(true);

    this.numerosMovimiento.play('numerosMovimiento');

    this.time.delayedCall(3000, () => {
      this.numerosMovimiento.stop();
      this.numerosMovimiento.setVisible(false);

      const colorKey = { Black: 'Negro', Red: 'Rojo', Green: 'Verde' }[color] || color;
      if (color === 'Black') {
        this.fondoNegroMovimiento.setVisible(true);
        this.fondoNegroMovimiento.play('fondoNegroMovimiento');
      } else if (color === 'Red') {
        this.fondoRojoMovimiento.setVisible(true);
        this.fondoRojoMovimiento.play('fondoRojoMovimiento');
      } else {
        this.fondoVerdeMovimiento.setVisible(true);
        this.fondoVerdeMovimiento.play('fondoVerdeMovimiento');
      }

      this.bolillaValor.setTexture(`ultimoNumero${numeroGanador}`);

      this.bolillaValor.setVisible(true);

      this.time.delayedCall(1200, () => {
        this.numerosMovimiento.stop();
        this.numerosMovimiento.setVisible(false);

        if (color === 'Black') {
          this.fondoNegroMovimiento.stop();
          this.fondoNegroMovimiento.setVisible(false);
        } else if (color === 'Red') {
          this.fondoRojoMovimiento.stop();
          this.fondoRojoMovimiento.setVisible(false);
        } else {
          this.fondoVerdeMovimiento.stop();
          this.fondoVerdeMovimiento.setVisible(false);
        }
        this.bolillaFondo.setTexture(`bolillaFondo${colorKey}`);
        this.bolillaFondo.setVisible(true);

        this.imagenesUltimosNumeros[4][1] = this.imagenesUltimosNumeros[3][1];
        this.imagenesUltimosNumeros[4][0].setTexture(
          `ultimoNumero${this.imagenesUltimosNumeros[3][1]}`
        );

        this.imagenesUltimosNumeros[3][1] = this.imagenesUltimosNumeros[2][1];
        this.imagenesUltimosNumeros[3][0].setTexture(
          `ultimoNumero${this.imagenesUltimosNumeros[2][1]}`
        );

        this.imagenesUltimosNumeros[2][1] = this.imagenesUltimosNumeros[1][1];
        this.imagenesUltimosNumeros[2][0].setTexture(
          `ultimoNumero${this.imagenesUltimosNumeros[1][1]}`
        );

        this.imagenesUltimosNumeros[1][1] = this.imagenesUltimosNumeros[0][1];
        this.imagenesUltimosNumeros[1][0].setTexture(
          `ultimoNumero${this.imagenesUltimosNumeros[0][1]}`
        );

        this.imagenesUltimosNumeros[0][1] = numeroGanador;
        this.imagenesUltimosNumeros[0][0].setTexture(
          `ultimoNumero${numeroGanador}`
        );
      });
    });
  }

  cargarFichasEnAlfombra() {
    for (
      let posicion = 0;
      posicion < this.posicionesApuesta.length;
      posicion++
    ) {
      // Verificar si hay una apuesta en la posición
      if (this.posicionesApuesta[posicion][1] > 0) {
        let coordenadas = obtenerCoordenadasPorPosicion(posicion);

        // Destruir ficha anterior si existe y detener animación
        if (this.posicionesApuesta[posicion][3]) {
          this.posicionesApuesta[posicion][3].destroy();
          this.posicionesApuesta[posicion][3] = null;
        }

        // Verificar si hay valores de ficha válidos
        let ultimaPosicion = this.posicionesApuesta[posicion][2].length - 1;
        if (ultimaPosicion >= 0) {
          let valorFicha = this.posicionesApuesta[posicion][2][ultimaPosicion];

          // Crear la ficha basada en el valor de la apuesta
          switch (valorFicha) {
            case 10:
              this.posicionesApuesta[posicion][3] = this.add.sprite(
                coordenadas.x,
                coordenadas.y,
                'fichaAlfombraValor10'
              );
              this.posicionesApuesta[posicion][3].setDepth(100);
              this.posicionesApuesta[posicion][3].play('fichaAlfombraValor10');
              break;

            case 20:
              this.posicionesApuesta[posicion][3] = this.add.sprite(
                coordenadas.x,
                coordenadas.y,
                'fichaAlfombraValor20'
              );
              this.posicionesApuesta[posicion][3].setDepth(100);
              this.posicionesApuesta[posicion][3].play('fichaAlfombraValor20');
              break;

            case 50:
              this.posicionesApuesta[posicion][3] = this.add.sprite(
                coordenadas.x,
                coordenadas.y,
                'fichaAlfombraValor50'
              );
              this.posicionesApuesta[posicion][3].setDepth(100);
              this.posicionesApuesta[posicion][3].play('fichaAlfombraValor50');
              break;

            case 100:
              this.posicionesApuesta[posicion][3] = this.add.sprite(
                coordenadas.x,
                coordenadas.y,
                'fichaAlfombraValor100'
              );
              this.posicionesApuesta[posicion][3].setDepth(100);
              this.posicionesApuesta[posicion][3].play('fichaAlfombraValor100');
              break;

            default:
              break;
          }
        }
      } else {
        // Si no hay apuesta, destruir cualquier ficha visible
        if (this.posicionesApuesta[posicion][3]) {
          this.posicionesApuesta[posicion][3].anims.stop();
          this.posicionesApuesta[posicion][3].removeFromDisplayList();
          this.posicionesApuesta[posicion][3].destroy();
          this.posicionesApuesta[posicion][3] = null;
        }
      }
    }
  }

  /* Cuando se selecciona una nueva ficha se cambia el valor de la variable fichaSeleccionadaValor
  Esta función se dispara como evento de FichasEleccion */
  cambiarFichaSeleccionadaValor(valor) {
    this.game.fichaSeleccionadaValor = valor;
  }

  // Actualiza el valor de la apuesta total
  actualizarApuestaTotal(valorFicha) {
    this.apuestaTotal += valorFicha;
    this.mostrarApuestaTotal();
  }

  // Muestra cartel de No va más en pantalla
  mostrarCartelNoVaMas() {
    this.cartelNoVaMas.setVisible(true);
    this.cartelNoVaMas.play('cartelNoVaMasAnimacion');

    this.time.delayedCall(1900, () => {
      this.cartelNoVaMas.stop();
      this.cartelNoVaMas.setVisible(false);
    });
  }

  // Muestra cartel de Hagan sus apuestas en pantalla
  mostrarCartelHaganSusApuestas() {
    this.cartelHaganSusApuestas.setVisible(true);
    this.cartelHaganSusApuestas.play('cartelHaganSusApuestasAnimacion');

    this.time.delayedCall(1900, () => {
      this.cartelHaganSusApuestas.stop();
      this.cartelHaganSusApuestas.setVisible(false);
    });
  }

  // Gira la ruleta
  girarRuleta() {
    this.ruleta.setVisible(false);
    this.ruletaGirando.setVisible(true);
    this.ruletaGirando.play('girarRuleta');

    this.time.delayedCall(3000, () => {
      this.ruletaGirando.stop();
      this.ruletaGirando.setVisible(false);
      this.ruleta.setVisible(true);
    });
  }

  /*/=======================================================================================\*\
  ||                               JUGAR APUESTA                                             ||
  \*\=======================================================================================/*/
  // Envía las apuestas al servidor, que genera el número ganador y calcula premios
  async jugarApuesta() {
    if (this.game.saldoDisponible >= this.apuestaTotal) {
      // Diferir actualizaciones de saldo por socket durante la animación
      startDeferring();
      this.game.saldoPendiente = null;

      // Descontar visualmente la apuesta del saldo
      this.game.saldoDisponible -= this.apuestaTotal;
      if (this.game.onApuestaIniciada) {
        this.game.onApuestaIniciada(this.apuestaTotal);
      }

      // Desactivar interacciones
      this.noVaMas = true;
      this.botonJugar.setTexture('botonJugarDesactivado');
      this.botonBorrar.setTexture('botonBorrarDesactivado');
      this.botonRepetir.setTexture('botonRepetirDesactivado');
      this.botonRestar.setTexture('botonRestarDesactivado');
      this.botonSumar.setTexture('botonSumarDesactivado');

      // Enviar apuestas al backend: el servidor genera el número y calcula premios
      let numeroGanador = 0;
      let color = 'Green';
      let premioTotalServidor = 0;
      let gananciasServidor = {};

      try {
        const response = await axiosInstance.post(
          '/api/jugadaRuleta/createJugadaRuleta',
          {
            posicionesApuesta: this.posicionesApuesta
              .filter((pos) => pos[1] > 0)
              .map((pos) => ({
                idPosicion: pos[6],
                montoTotalApostado: pos[1],
              })),
          }
        );
        numeroGanador = response.data.numeroGanador;
        color = response.data.color;
        premioTotalServidor = response.data.premioTotal;
        gananciasServidor = response.data.ganancias;
      } catch (err) {
        console.error('Error al registrar jugada:', err);
      }

      // Aplicar ganancias del servidor a las posiciones locales (para display)
      for (let i = 0; i < this.posicionesApuesta.length; i++) {
        this.posicionesApuesta[i][5] = 0;
      }
      for (const [idPos, ganancia] of Object.entries(gananciasServidor)) {
        const idx = parseInt(idPos);
        if (idx >= 0 && idx < this.posicionesApuesta.length) {
          this.posicionesApuesta[idx][5] = ganancia;
        }
      }

      // Indicar número ganador en alfombra
      let coordenadas = obtenerCoordenadasPorPosicion(numeroGanador);
      let imagenValorGanador = this.add.image(
        coordenadas.x,
        coordenadas.y,
        `valorGanador${numeroGanador}`
      );
      imagenValorGanador.setVisible(false);

      // Mostrar 0 inicialmente; el valor real se anima al final
      this.premioTotal = 0;
      this.mostrarPremioTotal();
      this.premioTotal = premioTotalServidor;
      this.mostrarCartelNoVaMas(); // tiempoFunc 1900

      // Animaciones de la ruleta
      this.time.delayedCall(1900, () => {
        this.girarRuleta(); // 3000
        this.moverNumeros(numeroGanador, color); // 3000 + 1200
      }); // tiempoFunc 4200

      // Indicar en la alfombra el número ganador
      this.time.delayedCall(6100, () => {
        imagenValorGanador.setVisible(true);
      });

      if (this.apuestaTotal > 0) {
        // Guarda una copia del arreglo de esta apuesta como ultimaApuesta
        this.almacenarUltimaApuesta();
        this.game.valorUltimaApuesta = this.apuestaTotal;
      }

      //-------------------------- FINALIZA JUGADA ------------------------------------------------\\
      this.time.delayedCall(6600, () => {
        this.actualizarPremioTotal();
        // Aplicar saldo real pendiente y reanudar actualizaciones por socket
        if (this.game.saldoPendiente != null) {
          this.game.saldoDisponible = this.game.saldoPendiente;
          this.game.saldoPendiente = null;
        }
        stopDeferring();

        // Refrescar saldo real en el SessionBar
        if (this.game.onPartidaFinalizada) {
          this.game.onPartidaFinalizada();
        }
      });
      this.time.delayedCall(7100, () => {
        // Muestra un cartel de hagan sus apuestas
        this.mostrarCartelHaganSusApuestas();
      });
      this.time.delayedCall(9000, () => {
        // Finaliza la apuesta, restaura valores y activa botones
        imagenValorGanador.setVisible(false);
        imagenValorGanador.destroy();
        this.borrarApuesta();
        this.noVaMas = false;
        this.botonJugar.setTexture('botonJugar');
        this.botonBorrar.setTexture('botonBorrar');
        this.botonRepetir.setTexture('botonRepetir');
        if (this.botonSumarActivado) {
          this.botonSumar.setTexture('botonSumarActivado');
        } else {
          this.botonRestar.setTexture('botonRestarActivado');
        }
      });
    }
  }
}

export default JuegoRuleta;
